import ValidService from '@/service/ValidService';
let model = {};

model.dataForm = {
    "id": undefined, // optional Mã tự sinh
    "loai": undefined,
    "duyet": // optional
    {
        "duoc_duyet": undefined, // optional Cho biết dịch vụ đã được duyệt hay chưa. true: đã duyệt, false: từ chối, null: chờ duyệt
        "thoi_diem_duyet": undefined, // optional Cho biết thời điểm dịch vụ đã được duyệt hoặc từ chối
        "nguoi_duyet_id": undefined, // optional Mã người duyệt
        "ly_do_tu_choi": undefined, // optional Lý do từ chối
    },
    "diem_den_an_toan_id": undefined, // required điểm đến id
    "link_dich_vu": [ // optional
        {
            "id": undefined, // optional id của dịch vụ
            "link": undefined, // optional Tên dịch vụ
        }
    ],
    "link_mang_xa_hoi": [ // optional - Đường dẫn đến các mạng xã hội
      {
        "name": 'Facebook',
        "link": undefined
      },
      {
        "name": 'Zalo',
        "link": undefined
      },
      {
        "name": 'Youtube',
        "link": undefined
      },
      {
        "name": 'Google',
        "link": undefined
      },
      {
        "name": 'Twitter',
        "link": undefined
      }
    ],
    "uu_dai": undefined, // optional Giá trị ưu đãi
    "loai_hinh_uu_dai": undefined,
    "gia_tri_uu_dai": undefined,
    "thong_tin_chung": // optional - Thông tin chung
    {
        "kinh_do": undefined, // optional - Kinh độ
        "vi_do": undefined, // optional - Vĩ độ
        "album_anh": [],
    },
    "luu_tru": // optional Lưu trú
    {
        "ten": undefined, // required Tên lưu trú
        "anh_hien_thi": null, // required Ảnh hiển thị
        "so_giuong_nguoi_lon": undefined, // optional Số giường người lớn
        "so_giuong_tre_em": undefined, // optional Số giường trẻ em
        "so_ngay_dat_phong": undefined, // optional Số ngày đặt phòng
        "mo_ta": undefined, // optional Mô tả lưu trú,
        "chi_tiet": undefined, // optional Mô tả lưu trú
        "gio_mo_cua": undefined, // optional Giờ mở cửa
        "gia_tien": undefined, // optional Giá tiền
    },
    "am_thuc": // optional Ẩm thực
    {
        "ten": undefined, // required Tên ẩm thực
        "anh_hien_thi": null, // required Ảnh hiển thị
        "mo_ta": undefined, // optional Mô tả ẩm thực
        "chi_tiet": undefined, // optional Chi tiết ẩm thực
    },
    "ve_dien_tu": // optional Vé điện tử
    {
        "ten": undefined, // required Tên vé điệnt tử
        "url": undefined, // required Đường dẫn vé điện tử
        "anh_hien_thi": null, // required Ảnh hiển thị
    },
    "diem_den": // optional Điểm đến
    {
        "ten": undefined, // optional Tên điểm đến
        "anh_hien_thi": null, // required Ảnh hiển thị
        "mo_ta": undefined, // optional Giới thiệu điểm đến
        "chi_tiet": undefined, // optional Chi tiết điểm đến
    },
    "giai_tri": // optional Giải trí
    {
        "ten": undefined, // required Tên địa điểm giải trí
        "anh_hien_thi": null, // required Ảnh hiển thị
        "mo_ta": undefined, // optional Giới thiệu về khu giải trí
        "chi_tiet": undefined, // optional Chi tiết về khi giải trí
    },
    "van_tai_khach": // optional - Vận tải khách
    {
        "ten": undefined, // optional - Tên đơn vị vận tải khách
        "anh_hien_thi": undefined, // optional, ref: mushroom_file - Ảnh hiển thị
        "mo_ta": undefined, // optional - Giới thiệu đơn vị vận tải khách
        "chi_tiet": undefined, // optional - Chi tiết đơn vị vận tải khách
    },
    "thoi_gian_tao": undefined, // optional
    "nguoi_tao": undefined, // required
    "thoi_gian_sua_cuoi": undefined, // optional Thời gian lần sửa bản ghi cuối cùng
    "nguoi_sua_cuoi": undefined, // optional Mã người sửa cuối
}
model.albumUploadOption = {
    accept: ".jpg, .png, .jpeg",
    dialogImageUrl: "",
    dialogVisible: false,
    fileList: []
}


// dữ liệu mẫu các form khác
model.dataFormOther = {
    fileUploadOption: {
        AnhDaiDien: {
            limit: 1,
            accept: ".jpg, .png, .jpeg",
            dialogImageUrl: "",
            dialogVisible: false,
            fileList: []
        },
        AnhGiayTo: {
            limit: null,
            accept: "",
            dialogImageUrl: "",
            dialogVisible: false,
            fileList: []
        }
    },
};





export default model;
